import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@storefront-ui/vue/styles.scss";
import {
  au
} from "@/firebase/init";
import './registerServiceWorker'
Vue.config.productionTip = false;
let app = null;
au.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
        created: function () {
          (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v10.0';
            fjs.parentNode.insertBefore(js, fjs);
          }(document, 'script', 'facebook-jssdk'));
        },
      router,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  }
});